module.exports = __webpack_public_path__ + "img/teaser_training3.dfae7178.jpg";